import { Capacitor } from "@capacitor/core";

// Rilevamento piattaforma: web / ios / android. Usato ovunque per scegliere
// l'implementazione corretta (browser vs nativa) senza duplicare codice.
export const isNative = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform(); // 'web' | 'ios' | 'android'
export const isIOS = () => Capacitor.getPlatform() === "ios";
export const isAndroid = () => Capacitor.getPlatform() === "android";
export const isWeb = () => !Capacitor.isNativePlatform();
